import { DateParser } from '@fnv-core/parsing';

export class FormControlMapping {
  public static GetComponentTypedValue = (value: any, componentidentifier: string) : any => {
    if(!value) {
      return null;
    }

    switch (componentidentifier) {
      case 'CalendarControl':
        return new DateParser().parse(value);
      case 'RadioButtonsControl':
      case 'TextBoxControl':
      case 'InitialsInputField':
      case 'DropDownListControl':
        return (value instanceof String) ? value?.trim() : value; 
      case 'internationalphone':
        return value?.replace(/[^\d+]/g, '');
      case 'emailinput':
        return value?.toLowerCase().trim();
      case 'CheckBoxControl':
      case 'ConsentAgreement':
        return value?.toLowerCase() === 'true';
      case 'GridControl':
        return JSON.parse(value);
      default:
        return value as any;
    }
  }
}